import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase-config";

export const useAuthUser = () =>
{
    const [userAuth, setUserAuth] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() =>
    {
        const unsub = onAuthStateChanged(auth, async (u) =>
        {
            try
            {
                if (u)
                {
                    await u.reload();
                    setUserAuth(auth.currentUser);
                }
                else
                {
                    setUserAuth(null);
                }
            }
            catch (error)
            {
                console.error("Auth reload failed:", error);
                setUserAuth(null);
            }

            setLoading(false);
        });

        return unsub;
    }, []);

    return { userAuth, loading };
};